import { IItem, IFreeItem } from 'src/app/account/modals/latest-transactions-modal/latest-transactions-modal.component';
//import { TranslateService } from '@ngx-translate/core';
import  { TranslationService } from 'src/app/shared/services/translation.service';

export class ItemHelpers {
    public static getTitle(item: IItem, translateService: TranslationService): string {
        const lang = translateService.getLanguage();
        let orText = translateService.translate('GENERAL.OR');

        let choices = item.Choices.map(t => {
            let ret = t.Description;
            if (t.Translations && t.Translations[lang] && t.Translations[lang].Description)
                ret = t.Translations[lang].Description;

            return ret;
        });

        let title = choices.reduce((p, c) => {
            if (p == '')
                return c;

            return `${p}\n${orText}\n${c}`;
        }, '');

        return title;
    }

    public static getTerms(item: IItem, lang: string): string {
        let terms = item.Choices.map(t => {
            let ret = t.Terms;
            if (t.Translations && t.Translations[lang] && t.Translations[lang].Terms)
                ret = t.Translations[lang].Terms;

            return ret;
        });

        let final = [];
        terms.forEach(term => {
            if (final.indexOf(term) === -1)
                final.push(term);
        });

        let ret = final.reduce((prev, curr) => {

            if (prev == '')
                return curr;

            return `${prev}\n\n${curr}`;
        }, '');

        return ret;
    }

    public static getDescriptionTrans(item: IFreeItem, lang: string): string {
        if (item.Translations.hasOwnProperty(lang))
            return item.Translations[lang].Description;

        return item.Description;
    }

    public static getTermsTrans(item: IFreeItem, lang: string): string {
        if (item.Translations.hasOwnProperty(lang))
            return item.Translations[lang].Terms;

        return item.Terms;
    }

    public static getOfferImage(item: IItem): string {
        for (let choice of item.Choices)
            if (choice.ImageUrl)
                return choice.ImageUrl;

        return "assets/imgs/default-empty.png";
    }
}